"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enrichINPMeasurement = enrichINPMeasurement;
exports.getImmediateId = getImmediateId;
function isINPMeasurementEvent(event) {
  var _event$payload, _event$payload2;
  return event.type === 'measurement' && ((_event$payload = event.payload) === null || _event$payload === void 0 ? void 0 : _event$payload.type) === 'web-vitals' && !!((_event$payload2 = event.payload) !== null && _event$payload2 !== void 0 && (_event$payload2 = _event$payload2.values) !== null && _event$payload2 !== void 0 && _event$payload2.inp);
}
function getImmediateId(element) {
  var _element$dataset, _element$dataset2;
  // Generated ids that have no value for us
  var idBlockList = ['__next'];
  if (!element) return undefined;
  if (element === document.body) return undefined;
  if (element.id && !idBlockList.includes(element.id)) return element.id;

  // It's not the ideal case, but given that it's not so common for us to have
  // id in our components, we can use the data-testid attribute as a fallback
  if ((_element$dataset = element.dataset) !== null && _element$dataset !== void 0 && _element$dataset.inpId || (_element$dataset2 = element.dataset) !== null && _element$dataset2 !== void 0 && _element$dataset2.testid) {
    var _ref, _element$dataset$inpI, _element$dataset3, _element$dataset4;
    return (_ref = (_element$dataset$inpI = (_element$dataset3 = element.dataset) === null || _element$dataset3 === void 0 ? void 0 : _element$dataset3.inpId) !== null && _element$dataset$inpI !== void 0 ? _element$dataset$inpI : (_element$dataset4 = element.dataset) === null || _element$dataset4 === void 0 ? void 0 : _element$dataset4.testid) !== null && _ref !== void 0 ? _ref : undefined;
  }
  if (element.parentNode && element.parentNode instanceof HTMLElement) {
    return getImmediateId(element.parentNode);
  }
  return undefined;
}
function getTargetElement(event) {
  var _event$payload3;
  var interactionTarget = (_event$payload3 = event.payload) === null || _event$payload3 === void 0 || (_event$payload3 = _event$payload3.context) === null || _event$payload3 === void 0 ? void 0 : _event$payload3.interaction_target;
  if (!interactionTarget) {
    return undefined;
  }
  try {
    var _document$querySelect;
    return (_document$querySelect = document.querySelector(interactionTarget)) !== null && _document$querySelect !== void 0 ? _document$querySelect : undefined;
  } catch (_unused) {
    // Handle invalid CSS selectors
    return undefined;
  }
}

/**
 * Grafana Faro event enrichment function for INP measurement events.
 * Adds the immediate_id, tag_name, and text_content to the event context.
 * Reference: https://grafana.com/docs/grafana-cloud/monitor-applications/frontend-observability/instrument/web-vitals/#interaction-to-next-paint-inp
 */
function enrichINPMeasurement(event) {
  if (isINPMeasurementEvent(event)) {
    var targetElement = getTargetElement(event);
    if (!targetElement) {
      return event;
    }
    if (event.payload && 'context' in event.payload && event.payload.context) {
      var immediateId = getImmediateId(targetElement);
      if (immediateId) {
        event.payload.context.immediate_id = immediateId;
      }
      if (targetElement !== null && targetElement !== void 0 && targetElement.tagName) {
        event.payload.context.tag_name = targetElement.tagName;
      }
      if (targetElement !== null && targetElement !== void 0 && targetElement.textContent) {
        event.payload.context.text_content = targetElement.textContent;
      }
    }
  }
  return event;
}